/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

/**
 * Lifecycle status of the call
 */
export type CallStatus = (typeof CallStatus)[keyof typeof CallStatus];

export const CallStatus = {
  STARTED: 'started',
  INPROGRESS: 'inProgress',
  COMPLETED: 'completed',
  PARTIAL: 'partial',
  FAILED: 'failed',
} as const;
